import { Int32StringTourListFeaturesViewModel } from '@api/v3';
import CustomIcon from '@components/utils/CustomIcon';
import { FeatureBullet } from '@assets/icons';
import Typography from '@components/Typography';
import palette from '@utils/theme/palette';
import Tooltip from '@components/ui/Tooltip/next';

import {
  DesktopFeatureGroup,
  DesktopFeaturesWrapper,
  ItemContainer,
  ShowMoreContainer,
  TooltipItemsContainer,
} from './styled';

const DesktopFeatures = ({
  hightlights,
}: {
  hightlights: Int32StringTourListFeaturesViewModel[];
}) => {
  const hiddenHightlights = hightlights
    ?.filter((item) => item.value !== 'Misafirler Öneriyor')
    ?.slice(3, hightlights.length);

  const filteredHighlights = hightlights?.filter(
    (item) =>
      item &&
      typeof item === 'object' && // Sadece nesneleri al
      Object.keys(item).length > 0 && // Boş nesneleri temizle
      item?.value && // `value` property'si varsa
      item.value !== 'Misafirler Öneriyor' // İstenmeyen değeri çıkar
  );

  const visibleHighlights =
    filteredHighlights.length > 0 ? filteredHighlights.slice(0, 3) : null;

  // Eğer `visibleHighlights` null ise, return ile bileşeni tamamen sonlandır
  if (!visibleHighlights) return null;

  return (
    <DesktopFeaturesWrapper>
      <DesktopFeatureGroup>
        <>
          {visibleHighlights
            ? visibleHighlights.map((item) => (
                <ItemContainer key={item.key}>
                  <CustomIcon icon={FeatureBullet} fontSize={4} />
                  <Typography variant='caption3' weight='Regular' color='NL500'>
                    {item.value}
                  </Typography>
                </ItemContainer>
              ))
            : null}
        </>
      </DesktopFeatureGroup>
      {hightlights && hightlights.length > 5 ? (
        <Tooltip
          overlayInnerStyle={{
            textAlign: 'left',
            width: '250px',
            backgroundColor: palette.NL0,
            padding: '8px',
          }}
          arrowColor={palette.NL0}
          overlayStyle={{
            backgroundColor: palette.NL0,
            borderRadius: '8px',
          }}
          placement='bottom'
          title={
            <TooltipItemsContainer>
              {hiddenHightlights?.map((item) => (
                <Typography
                  variant='caption2'
                  weight='Light'
                  color='D400'
                  key={item.key}
                  as='div'
                >
                  · {item.value}
                </Typography>
              ))}
            </TooltipItemsContainer>
          }
          getPopupContainer={(node) => node}
        >
          <ShowMoreContainer>
            <Typography color='NL800' variant='caption3' weight='Bold'>
              +{hiddenHightlights.length}
            </Typography>
          </ShowMoreContainer>
        </Tooltip>
      ) : null}
    </DesktopFeaturesWrapper>
  );
};

export default DesktopFeatures;
